import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import { cn } from "@/lib/utils";

export function ThemeToggle({ className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      onClick={toggleTheme}
      className={cn("theme-switch", className)}
      aria-label={label}
    >
      <span className="theme-switch-thumb" />
      <span className="theme-switch-slot">
        <Sun size={16} strokeWidth={2.25} aria-hidden="true" />
      </span>
      <span className="theme-switch-slot">
        <Moon size={16} strokeWidth={2.25} aria-hidden="true" />
      </span>
    </button>
  );
}
